import React from 'react';
import { color as palette } from "@/constants/palette";

function CircleArrowRight() {
  return (
    <svg aria-hidden="true" focusable="false"
      xmlns='http://www.w3.org/2000/svg'
      width='26'
      height='26'
      viewBox='0 0 26 26'
      fill='none'
    >
      <rect width='26' height='26' rx='13' fill={palette.fill} />
      <path
        d='M13.6258 6.27706C13.2539 5.90765 12.6509 5.90765 12.2789 6.27706C11.907 6.64648 11.907 7.24542 12.2789 7.61483L16.6939 12H7C6.44772 12 6 12.4477 6 13C6 13.5523 6.44772 14 7 14H16.6939L12.2789 18.3852C11.907 18.7546 11.907 19.3535 12.2789 19.7229C12.6509 20.0924 13.2539 20.0924 13.6258 19.7229L19.5608 13.8281C19.8251 13.6487 19.999 13.3461 20 13.0028L20 13L20 12.9972C19.999 12.6539 19.8251 12.3513 19.5608 12.1719L13.6258 6.27706Z'
        fill={palette.disabled}
      />
    </svg>
  );
}

export default CircleArrowRight;
